<form [formGroup]="form">
  <label [for]="settings.idName" [ngClass]="{ 'text-danger': errorMessage }">{{
    settings.label
  }}</label>
  <tooltip
    [title]="'Select ' + settings.label"
    placement="right"
    delay="200"
  ></tooltip>
  <div class="input-group">
    <input
      type="text"
      class="form-control col-12"
      placement="bottom"
      [value]="settings.value"
      [ngClass]="{ 'border-danger': errorMessage }"
      [placeholder]="settings.placeholder"
      [bsConfig]="getDatePickerConfig()"
      [formControlName]="settings.formControlName"
      [minDate]="settings.minDate"
      [maxDate]="settings.maxDate"
      [daysDisabled]="settings.disableDays"
      [datesDisabled]="settings.disabledDates"
      [isDisabled]="true"
      [outsideClick]="settings.outSideClick"
      [isOpen]="isOpen"
      [id]="settings.idName"
      (change)="onChange($event.target.value)"
      (blur)="onBlurEvent($event.target.value)"
      (bsValueChange)="onChange($event)"
      #dp="bsDatepicker"
      bsDatepicker
    />
    <div class="input-group-append">
      <button
        class="input-group-text btn"
        [ngClass]="{ 'border-danger': errorMessage }"
        (click)="calanderClicked()"
      >
        <span
          class="fa fa-calendar-check-o"
          [ngClass]="{ 'text-danger': errorMessage }"
        ></span>
      </button>
    </div>
  </div>
  <p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
</form>
